const NumberUtility = {
    format(value: number | string, decimalPlaces: number | undefined = 0, alwaysShowDecimals: boolean | undefined = false, showThousandsSeparator: boolean | undefined = false, decimalSeparator: string | undefined = ',', thousandsSeparator: string | undefined = '.') : string {
        if (value === undefined || value === null)
            return '';

        let result = value.toString().replace('.', decimalSeparator);
        
        if (showThousandsSeparator) {
            let splitValue = result.split(decimalSeparator);
            splitValue[0] = splitValue[0].replace(/(\d)(?=(?:[\d]{3})+\b)/gm, "$1" + thousandsSeparator);
            result = splitValue.join(decimalSeparator);
        }
        if (decimalPlaces > 0) {
            let splitValue = result.split(decimalSeparator);
            if (splitValue.length > 1 && splitValue[1].length > decimalPlaces) {
                splitValue[1] = splitValue[1].substring(0, decimalPlaces);
            }
            result = splitValue.join(decimalSeparator);
        }
        if (alwaysShowDecimals) {
            result = this.setFixedDecimalLength(result, decimalPlaces, decimalSeparator);
        }
        return result;
    },

    setFixedDecimalLength(value: string, decimalPlaces: number | undefined = 0, decimalSeparator: string | undefined = ',') {
        if (value !== undefined && value !== '' && decimalPlaces > 0) {
            let splitValue = value.split(decimalSeparator);
            let decimalPart = splitValue.length > 1 ? splitValue[1] : '';
            if (decimalPart.length < decimalPlaces) {
                decimalPart += '0'.repeat(decimalPlaces - decimalPart.length);
            }
            value = splitValue[0] + decimalSeparator + decimalPart;
        }
        return value;
    }
};

export default NumberUtility;